/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createOneBaseMgmtOrderpickerControllerOrderpickerCompany } from '../fn/orderpicker/create-one-base-mgmt-orderpicker-controller-orderpicker-company';
import { CreateOneBaseMgmtOrderpickerControllerOrderpickerCompany$Params } from '../fn/orderpicker/create-one-base-mgmt-orderpicker-controller-orderpicker-company';
import { createOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget } from '../fn/orderpicker/create-one-base-mgmt-orderpicker-target-controller-orderpicker-target';
import { CreateOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Params } from '../fn/orderpicker/create-one-base-mgmt-orderpicker-target-controller-orderpicker-target';
import { deleteOneBaseMgmtOrderpickerControllerOrderpickerCompany } from '../fn/orderpicker/delete-one-base-mgmt-orderpicker-controller-orderpicker-company';
import { DeleteOneBaseMgmtOrderpickerControllerOrderpickerCompany$Params } from '../fn/orderpicker/delete-one-base-mgmt-orderpicker-controller-orderpicker-company';
import { deleteOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget } from '../fn/orderpicker/delete-one-base-mgmt-orderpicker-target-controller-orderpicker-target';
import { DeleteOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Params } from '../fn/orderpicker/delete-one-base-mgmt-orderpicker-target-controller-orderpicker-target';
import { getManyBaseMgmtOrderpickerControllerOrderpickerCompany } from '../fn/orderpicker/get-many-base-mgmt-orderpicker-controller-orderpicker-company';
import { GetManyBaseMgmtOrderpickerControllerOrderpickerCompany$Params } from '../fn/orderpicker/get-many-base-mgmt-orderpicker-controller-orderpicker-company';
import { getManyBaseMgmtOrderpickerTargetControllerOrderpickerTarget } from '../fn/orderpicker/get-many-base-mgmt-orderpicker-target-controller-orderpicker-target';
import { GetManyBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Params } from '../fn/orderpicker/get-many-base-mgmt-orderpicker-target-controller-orderpicker-target';
import { GetManyOrderpickerCompanyResponseDto } from '../models/get-many-orderpicker-company-response-dto';
import { GetManyOrderpickerTargetResponseDto } from '../models/get-many-orderpicker-target-response-dto';
import { getOneBaseMgmtOrderpickerControllerOrderpickerCompany } from '../fn/orderpicker/get-one-base-mgmt-orderpicker-controller-orderpicker-company';
import { GetOneBaseMgmtOrderpickerControllerOrderpickerCompany$Params } from '../fn/orderpicker/get-one-base-mgmt-orderpicker-controller-orderpicker-company';
import { getOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget } from '../fn/orderpicker/get-one-base-mgmt-orderpicker-target-controller-orderpicker-target';
import { GetOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Params } from '../fn/orderpicker/get-one-base-mgmt-orderpicker-target-controller-orderpicker-target';
import { OrderpickerCompany } from '../models/orderpicker-company';
import { OrderpickerTarget } from '../models/orderpicker-target';
import { updateOneBaseMgmtOrderpickerControllerOrderpickerCompany } from '../fn/orderpicker/update-one-base-mgmt-orderpicker-controller-orderpicker-company';
import { UpdateOneBaseMgmtOrderpickerControllerOrderpickerCompany$Params } from '../fn/orderpicker/update-one-base-mgmt-orderpicker-controller-orderpicker-company';
import { updateOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget } from '../fn/orderpicker/update-one-base-mgmt-orderpicker-target-controller-orderpicker-target';
import { UpdateOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Params } from '../fn/orderpicker/update-one-base-mgmt-orderpicker-target-controller-orderpicker-target';

@Injectable({ providedIn: 'root' })
export class OrderpickerApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getManyBaseMgmtOrderpickerControllerOrderpickerCompany()` */
  static readonly GetManyBaseMgmtOrderpickerControllerOrderpickerCompanyPath = '/api/mgmt/orderpickers';

  /**
   * Retrieve multiple OrderpickerCompanies.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtOrderpickerControllerOrderpickerCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtOrderpickerControllerOrderpickerCompany$Response(params?: GetManyBaseMgmtOrderpickerControllerOrderpickerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyOrderpickerCompanyResponseDto>> {
    const obs = getManyBaseMgmtOrderpickerControllerOrderpickerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple OrderpickerCompanies.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtOrderpickerControllerOrderpickerCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtOrderpickerControllerOrderpickerCompany(params?: GetManyBaseMgmtOrderpickerControllerOrderpickerCompany$Params, context?: HttpContext): Observable<GetManyOrderpickerCompanyResponseDto> {
    const resp = this.getManyBaseMgmtOrderpickerControllerOrderpickerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyOrderpickerCompanyResponseDto>): GetManyOrderpickerCompanyResponseDto => r.body)
    );
  }

  /** Path part for operation `createOneBaseMgmtOrderpickerControllerOrderpickerCompany()` */
  static readonly CreateOneBaseMgmtOrderpickerControllerOrderpickerCompanyPath = '/api/mgmt/orderpickers';

  /**
   * Create a single OrderpickerCompany.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOneBaseMgmtOrderpickerControllerOrderpickerCompany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtOrderpickerControllerOrderpickerCompany$Response(params: CreateOneBaseMgmtOrderpickerControllerOrderpickerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderpickerCompany>> {
    const obs = createOneBaseMgmtOrderpickerControllerOrderpickerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a single OrderpickerCompany.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOneBaseMgmtOrderpickerControllerOrderpickerCompany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtOrderpickerControllerOrderpickerCompany(params: CreateOneBaseMgmtOrderpickerControllerOrderpickerCompany$Params, context?: HttpContext): Observable<OrderpickerCompany> {
    const resp = this.createOneBaseMgmtOrderpickerControllerOrderpickerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrderpickerCompany>): OrderpickerCompany => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtOrderpickerControllerOrderpickerCompany()` */
  static readonly GetOneBaseMgmtOrderpickerControllerOrderpickerCompanyPath = '/api/mgmt/orderpickers/{id}';

  /**
   * Retrieve a single OrderpickerCompany.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtOrderpickerControllerOrderpickerCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtOrderpickerControllerOrderpickerCompany$Response(params: GetOneBaseMgmtOrderpickerControllerOrderpickerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderpickerCompany>> {
    const obs = getOneBaseMgmtOrderpickerControllerOrderpickerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single OrderpickerCompany.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtOrderpickerControllerOrderpickerCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtOrderpickerControllerOrderpickerCompany(params: GetOneBaseMgmtOrderpickerControllerOrderpickerCompany$Params, context?: HttpContext): Observable<OrderpickerCompany> {
    const resp = this.getOneBaseMgmtOrderpickerControllerOrderpickerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrderpickerCompany>): OrderpickerCompany => r.body)
    );
  }

  /** Path part for operation `deleteOneBaseMgmtOrderpickerControllerOrderpickerCompany()` */
  static readonly DeleteOneBaseMgmtOrderpickerControllerOrderpickerCompanyPath = '/api/mgmt/orderpickers/{id}';

  /**
   * Delete a single OrderpickerCompany.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOneBaseMgmtOrderpickerControllerOrderpickerCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtOrderpickerControllerOrderpickerCompany$Response(params: DeleteOneBaseMgmtOrderpickerControllerOrderpickerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteOneBaseMgmtOrderpickerControllerOrderpickerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a single OrderpickerCompany.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOneBaseMgmtOrderpickerControllerOrderpickerCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtOrderpickerControllerOrderpickerCompany(params: DeleteOneBaseMgmtOrderpickerControllerOrderpickerCompany$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteOneBaseMgmtOrderpickerControllerOrderpickerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMgmtOrderpickerControllerOrderpickerCompany()` */
  static readonly UpdateOneBaseMgmtOrderpickerControllerOrderpickerCompanyPath = '/api/mgmt/orderpickers/{id}';

  /**
   * Update a single OrderpickerCompany.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMgmtOrderpickerControllerOrderpickerCompany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtOrderpickerControllerOrderpickerCompany$Response(params: UpdateOneBaseMgmtOrderpickerControllerOrderpickerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderpickerCompany>> {
    const obs = updateOneBaseMgmtOrderpickerControllerOrderpickerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a single OrderpickerCompany.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMgmtOrderpickerControllerOrderpickerCompany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtOrderpickerControllerOrderpickerCompany(params: UpdateOneBaseMgmtOrderpickerControllerOrderpickerCompany$Params, context?: HttpContext): Observable<OrderpickerCompany> {
    const resp = this.updateOneBaseMgmtOrderpickerControllerOrderpickerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrderpickerCompany>): OrderpickerCompany => r.body)
    );
  }

  /** Path part for operation `getManyBaseMgmtOrderpickerTargetControllerOrderpickerTarget()` */
  static readonly GetManyBaseMgmtOrderpickerTargetControllerOrderpickerTargetPath = '/api/mgmt/orderpicker/{orderpickerId}/targets';

  /**
   * Retrieve multiple OrderpickerTargets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtOrderpickerTargetControllerOrderpickerTarget()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Response(params: GetManyBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyOrderpickerTargetResponseDto>> {
    const obs = getManyBaseMgmtOrderpickerTargetControllerOrderpickerTarget(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple OrderpickerTargets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtOrderpickerTargetControllerOrderpickerTarget(params: GetManyBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Params, context?: HttpContext): Observable<GetManyOrderpickerTargetResponseDto> {
    const resp = this.getManyBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyOrderpickerTargetResponseDto>): GetManyOrderpickerTargetResponseDto => r.body)
    );
  }

  /** Path part for operation `createOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget()` */
  static readonly CreateOneBaseMgmtOrderpickerTargetControllerOrderpickerTargetPath = '/api/mgmt/orderpicker/{orderpickerId}/targets';

  /**
   * Create a single OrderpickerTarget.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Response(params: CreateOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderpickerTarget>> {
    const obs = createOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a single OrderpickerTarget.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget(params: CreateOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Params, context?: HttpContext): Observable<OrderpickerTarget> {
    const resp = this.createOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrderpickerTarget>): OrderpickerTarget => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget()` */
  static readonly GetOneBaseMgmtOrderpickerTargetControllerOrderpickerTargetPath = '/api/mgmt/orderpicker/{orderpickerId}/targets/{id}';

  /**
   * Retrieve a single OrderpickerTarget.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Response(params: GetOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderpickerTarget>> {
    const obs = getOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single OrderpickerTarget.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget(params: GetOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Params, context?: HttpContext): Observable<OrderpickerTarget> {
    const resp = this.getOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrderpickerTarget>): OrderpickerTarget => r.body)
    );
  }

  /** Path part for operation `deleteOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget()` */
  static readonly DeleteOneBaseMgmtOrderpickerTargetControllerOrderpickerTargetPath = '/api/mgmt/orderpicker/{orderpickerId}/targets/{id}';

  /**
   * Delete a single OrderpickerTarget.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Response(params: DeleteOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a single OrderpickerTarget.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget(params: DeleteOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget()` */
  static readonly UpdateOneBaseMgmtOrderpickerTargetControllerOrderpickerTargetPath = '/api/mgmt/orderpicker/{orderpickerId}/targets/{id}';

  /**
   * Update a single OrderpickerTarget.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Response(params: UpdateOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderpickerTarget>> {
    const obs = updateOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a single OrderpickerTarget.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget(params: UpdateOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Params, context?: HttpContext): Observable<OrderpickerTarget> {
    const resp = this.updateOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrderpickerTarget>): OrderpickerTarget => r.body)
    );
  }

}
